var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { deleteBetSlip as deleteBetSlipAction } from '../../../../actions/coupon/creators/coupon';
import { addQuickBetRate as addQuickBetRateAction } from '../../../../actions/coupon/creators/quickbet';
import { getRateDisplayValue } from '../../../../rendering-commons';
var Rate = /** @class */ (function (_super) {
    __extends(Rate, _super);
    function Rate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // onClick = (e) => {
        //     e.preventDefault();
        //     const {rate, match, outcome, isInCoupon} = this.props;
        //     if (!isInCoupon) {
        //         this.props.addQuickBetRateAction({rate, match, outcome});
        //     } else {
        //         this.props.deleteBetSlipAction(rate.get('id'));
        //     }
        // };
        _this.onClick = function (e) {
            e.preventDefault();
            var _a = _this.props, rate = _a.rate, match = _a.match, outcome = _a.outcome, isInCoupon = _a.isInCoupon;
            if (!isInCoupon) {
                _this.props.addQuickBetRateAction({ rate: rate, match: match, outcome: outcome });
            }
            else {
                _this.props.deleteBetSlipAction(rate.get('id'));
            }
        };
        return _this;
    }
    Rate.prototype.render = function () {
        var _a = this.props, rate = _a.rate, isInCoupon = _a.isInCoupon;
        var value = getRateDisplayValue(rate.get('value'));
        var rateCls = isInCoupon ? 'rate added' : 'rate';
        var isAvailable = value > 1;
        return (_jsx("div", __assign({ className: rateCls, onClick: isAvailable ? this.onClick : null }, { children: _jsx("span", __assign({ className: 'metka' }, { children: isAvailable ? value : "--" })) })));
    };
    return Rate;
}(React.Component));
Rate.propTypes = {
    isInCoupon: PropTypes.bool.isRequired,
    bettingMode: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    match: PropTypes.object,
    outcome: PropTypes.object,
    first: PropTypes.bool,
    outcomeName: PropTypes.string.isRequired,
    addQuickBetRateAction: PropTypes.func.isRequired,
};
function mapStateToProps(state, props) {
    var id = props.id, section = props.section, gridLocalization = props.gridLocalization;
    var rate = state.application.getIn([section, 'rates', id]);
    var isInCoupon = state.coupon.get('betSlips').has(id);
    var match = state.application.getIn([section, 'matches', rate.get('matchId')]);
    var outcome = state.application.getIn([section, 'outcomes', rate.get('outcomeId')]);
    var rateWithName = rate;
    if (match) {
        var sportId = match.get('realSportId');
        var matchObj = {
            homeTeam: match.get('firstTeam'),
            awayTeam: match.get('secondTeam')
        };
        var outcomeObj = outcome.toJS();
        outcomeObj.name = gridLocalization.getOutcomeName(sportId, outcomeObj, matchObj);
        outcome = Immutable.fromJS(outcomeObj);
        var rateObj = rate.toJS();
        rateObj.shortName = gridLocalization.getRateName(sportId, outcomeObj, rate.get('type'), matchObj);
        if (section === 'live' || section === 'liveMatch') {
            rateObj.isLive = true;
        }
        rateWithName = Immutable.fromJS(rateObj);
    }
    return {
        rate: rateWithName,
        match: match,
        outcome: outcome,
        isInCoupon: isInCoupon,
        bettingMode: state.application.get('bettingMode'),
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    addQuickBetRateAction: addQuickBetRateAction,
    deleteBetSlipAction: deleteBetSlipAction,
}, dispatch); };
Rate = connect(mapStateToProps, mapDispatchToProps)(Rate);
export default Rate;



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/Rate.jsx